import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsRequestPage.ReportSettings', {
    title: 'This report shows {type}s that match the following filter:',
    titleNoFilters: 'This report shows all {type}s',
    buttonReportSetup: 'Report setup',
    request: 'request',
});
